/* COMPONENT - C09.01 Language Selection */
'use strict';

import Cookies from 'js-cookie'

export default class LanguageSelection {
    constructor(element) {
        if (this.checkCookie()) {
            this.root = element;
            this.closeBtn = this.root.querySelector('.language-selection__close');
            this.closeModalBtn = this.root.querySelector('.language-selection__modal-close');
            this.form = this.root.querySelector('.language-selection__form');
            this.lastModalBtn = this.root.querySelector('.language-selection__save-dont');
            this.persistentField = this.root.querySelector('.language-selection__persistent')
            this.openModalBtn = this.root.querySelector('.language-selection__modal-trigger');  
            this.saveDontBtn = this.root.querySelector('.language-selection__save-dont');
              
            this.showBar();
            this.bindEvents();
        }
    }
    bindEvents() {
        this.closeBtn.addEventListener('click', this.hideBar.bind(this));
        this.closeModalBtn.addEventListener('keydown', this.focusLock.bind(this));
        this.closeModalBtn.addEventListener('click', this.toggleModal.bind(this));
        this.lastModalBtn.addEventListener('keydown', this.focusLock.bind(this));
        this.openModalBtn.addEventListener('click', this.toggleModal.bind(this));
        this.saveDontBtn.addEventListener('click', this.persistCookieOnSave.bind(this));
    }
    checkCookie() {
        return Cookies.get('brcHideLanguageBar') !== 'true';
    }
    focusLock(e) {
        if (e.keyCode === 9) {
            if (e.shiftKey === true && e.target === this.closeModalBtn) {
                e.preventDefault();
                this.lastModalBtn.focus();
            } else if (e.shiftKey === false && e.target === this.lastModalBtn) {
                e.preventDefault();
                this.closeModalBtn.focus();
            }
        }
    }
    hideBar() {
        this.root.setAttribute('hidden', 'hidden');
        Cookies.set('brcHideLanguageBar', 'true');
    }
    persistCookieOnSave(e) {
        e.preventDefault();
        this.persistentField.value = true;
        this.form.submit();
    }
    showBar() {
        this.root.removeAttribute('hidden');
    }
    toggleModal() {
        if (this.form.classList.contains('language-selection__form--show')) {
            this.openModalBtn.focus();
            this.form.classList.remove('language-selection__form--show');
        } else {
            this.form.classList.add('language-selection__form--show');
            this.closeModalBtn.focus();
        }
    }
}
